<div *ngIf="masterMenu">
    <ng-container *ngFor="let item of masterMenu.MainItems; let menuIdx = index;">
        <ng-container *ngIf="item && item.TargetType === 'url'; else internalLink">
            <a href="{{item.Target}}" [target]="item.OpenInNewWindow ? '_blank' : ''">{{item.Title}}</a>
        </ng-container>
        <ng-template #internalLink>
            <ng-container *ngIf="item && item.SubMenu.length > 0; else topLevelMenu">
                <mat-expansion-panel class="main-menu-header" #mainItemExpansionPanels [attr.panelId]="'main' + menuIdx"
                    hideToggle="true">
                    <mat-expansion-panel-header collapsedHeight="30px" expandedHeight="30px" (click)="expandMainItemPanel($event)">
                        <mat-panel-title>
                            <a class="main-menu-link"
                                [routerLink]="[ '/' + languageCode, item.TargetType, item.Target.toLowerCase() ]"
                                [target]="item.OpenInNewWindow ? '_blank' : ''">
                                {{item.Title}}
                            </a>
                        </mat-panel-title>
                        <mat-icon (click)="openPanel('main' + menuIdx)">
                            {{isPanelOpen("main" + menuIdx) ? "keyboard_arrow_down" : "chevron_right"}}</mat-icon>
                    </mat-expansion-panel-header>
                    <ng-container *ngFor="let subItem of item.SubMenu">
                        <p>
                            <ng-container
                                *ngIf="subItem.TargetType === 'page' && subItem.Target === LOGINFORMName; else nonLoginLink">
                                <a class="main-menu-sub-item"
                                    [routerLink]="[ '/' + languageCode, subItem.TargetType, subItem.Target.toLowerCase() ]"
                                    [queryParams]="{ returnUrl: router.url }"
                                    [target]="subItem.OpenInNewWindow ? '_blank' : ''">
                                    {{subItem.Title}}
                                </a>
                            </ng-container>
                            <ng-template #nonLoginLink>
                                <a class="main-menu-sub-item"
                                    [routerLink]="[ '/' + languageCode, subItem.TargetType, subItem.Target.toLowerCase() ]"
                                    [target]="subItem.OpenInNewWindow ? '_blank' : ''">
                                    {{subItem.Title}}
                                </a>
                            </ng-template>
                        </p>
                    </ng-container>
                </mat-expansion-panel>
            </ng-container>
            <ng-template #topLevelMenu>
                <p>
                    <a
                        [routerLink]="[ '/' + languageCode, item.TargetType, item.Target.toLowerCase() ]">{{item.Title}}</a>
                </p>
            </ng-template>
        </ng-template>
    </ng-container>
    <p class="divider dropdown-divider"></p>
    <mat-expansion-panel class="main-menu-header" #languagesPanel hideToggle="true">
        <mat-expansion-panel-header collapseHeight="30px" expandedHeight="30px" (click)="expandLanguagesPanel($event)">
            <mat-panel-title>{{masterMenu.LanguageItem.Title}}</mat-panel-title>
            <mat-icon (click)="openPanel('languages')">
                {{isPanelOpen("languages") ? "keyboard_arrow_down" : "chevron_right"}}</mat-icon>
        </mat-expansion-panel-header>
        <ng-container *ngFor="let subItem of masterMenu.LanguageItem.SubMenu">
            <p>
                <a class="main-menu-sub-item" href="javascript:void(0)"
                    (click)="changeLanguage(subItem)">{{subItem.Title}}</a>
            </p>
        </ng-container>
    </mat-expansion-panel>
    <p class="divider dropdown-divider"></p>
    <a class="main-menu-item" href="https://www.usnr.com/en/page/home?dt=1">{{masterMenu.DesktopSiteText}}</a>
    <p class="divider dropdown-divider"></p>
    <a class="main-menu-item main-menu-portal"
        *ngIf="masterMenu.ToolbarItems && masterMenu.ToolbarItems.length > 0 && masterMenu.ToolbarItems[0].Target === 'LoginForm'"
        [routerLink]="['/' + languageCode, 'page', masterMenu.ToolbarItems[0].Target]">
        {{masterMenu.ToolbarItems[0].Title}}
    </a>
    <a class="main-menu-item main-menu-portal"
        *ngIf="masterMenu.ToolbarItems && masterMenu.ToolbarItems.length > 0 && masterMenu.ToolbarItems[0].Target && masterMenu.ToolbarItems[0].Target !== 'LoginForm'"
        [routerLink]="['/' + languageCode, 'page', masterMenu.ToolbarItems[0].Target]">
        {{masterMenu.ToolbarItems[0].Title}}
    </a>
    <div *ngIf="masterMenu.ToolbarItems && masterMenu.ToolbarItems.length > 0">
        <ng-container *ngFor="let subItem of masterMenu.ToolbarItems[0].SubMenu">
            <p class="main-menu-user-info">
                {{subItem.Title}}
            </p>
        </ng-container>
    </div>
    <p *ngIf="masterMenu.ToolbarItems && masterMenu.ToolbarItems.length > 0 &&  masterMenu.ToolbarItems[0].SubMenu.length > 0">
        <a class="main-menu-item" href="javascript:void(0)" (click)="signoutUser()">{{masterMenu.SignoutText}}</a>
    </p>
    <p class="divider dropdown-divider"></p>
    <p class="main-menu-copyright">{{masterMenu.Copyright}}</p>
</div>
